import request from '@/utils/request';

const PATH = '/reservation/client';

export const getReservationClientList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getReservationClientAll = (params: any) => request({
  url: `${PATH}/all`,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getReservationClient = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});

export const getReservationClientForm = (uid: string) => request({
  url: `${PATH}/${uid}/form`,
  method: 'get',
});

export const getReservationClientPriceInfo = (uid: string) => request({
  url: `${PATH}/${uid}/price`,
  method: 'get',
});

export const checkReservationClient = (uid: string, params: any) => request({
  url: `${PATH}/${uid}/check`,
  method: 'get',
  params,
});

export const getCalculateInfo = (params: any) => request({
  url: `${PATH}/calculate/info`,
  method: 'get',
  params,
});

export const approvalReservationClient = (uid: string, data: any) => request({
  url: `${PATH}/${uid}`,
  method: 'put',
  data,
});

export const updateReservationClient = (uid: string, data: any) => request({
  url: `${PATH}/${uid}/info`,
  method: 'put',
  data,
});

export const cancelReservationClient = (uid: string, data: any) => request({
  url: `${PATH}/${uid}/cancel`,
  method: 'put',
  data,
});

export const doneReservationClient = (uid: string) => request({
  url: `${PATH}/${uid}/done`,
  method: 'put',
});

export const getGroupInfo = (clientUid: string) => request({
  url: `${PATH}/${clientUid}/group/info`,
  method: 'get',
});

export const downloadCalculateExcel = (params: any) => request({
  url: `${PATH}/calculate/excel`,
  method: 'get',
  params,
  responseType: 'blob',
});

export const downloadBusinessExcel = (params: any) => request({
  url: `${PATH}/business/excel`,
  method: 'get',
  params,
  responseType: 'blob',
});
